/**
 * Type definitions for Special Access API response
 */

export enum ConsumptionStateCategoryEnum {
  Initial = "initial",
  Claimed = "claimed",
  Consumption = "consumption",
  Terminal = "terminal",
}

export const consumptionStateCategoryValues: {
  [k in ConsumptionStateCategoryEnum]: number;
} = {
  [ConsumptionStateCategoryEnum.Initial]: 0,
  [ConsumptionStateCategoryEnum.Claimed]: 1,
  [ConsumptionStateCategoryEnum.Consumption]: 2,
  [ConsumptionStateCategoryEnum.Terminal]: 5,
};

export interface ContentThumbnail {
  horizontal: string;
  vertical: string;
  square: string;
}

export interface Content {
  id: number;
  all_ids: string[];
  slug: string;
  thumbnail: ContentThumbnail;
  title: string;
  trailer: string;
  type: string;
  watch_duration: number;
}

export interface CTA {
  action: string;
  bg_color: string;
  prefix_icon: string;
  text: string;
  text_color: string;
}

export interface FloatingBanner {
  cta: CTA;
  description: string;
  image: string;
  title: string;
}

export interface AnimationDurations {
  gift: number;
  start_watching: number;
  thumbnail: number;
}

export interface VideoPositions {
  claim_button: number;
  start_watching_button: number;
  thumbnail: number;
}

export interface OfferPage {
  animation_durations: AnimationDurations;
  asset_type: string;
  asset_url: string;
  cta_claim: CTA;
  cta_start_watching: CTA;
  video_positions: VideoPositions;
  thumbnail_bottom_factor: string;
  thumbnail_width_factor: string;
}

export interface HookClipDescription {
  color: string;
  text: string;
}

export interface HookClipTitle {
  color: string;
  text: string;
}

export interface HookClip {
  asset_type: string;
  asset_url: string;
  cta: CTA;
  description: HookClipDescription;
  tag_url: string;
  title: HookClipTitle;
  tag_text: string;
}

export interface Platter {
  asset_type: string;
  asset_url: string;
  cta: CTA;
  tag_url: string;
}

export interface SpecialAccessState {
  state_category: ConsumptionStateCategoryEnum;
  state_value: number;
  consumption_tag_text?: string;
  floating_banner?: FloatingBanner;
  offer_page?: OfferPage;
  hook_clip?: HookClip;
  platter?: Platter;
  slot?: number;
  thumbnail_tag_url?: string;
}

export interface SpecialAccessResponse {
  content: Content;
  current_state_category: ConsumptionStateCategoryEnum;
  current_state_slot: number;
  current_state_value: number;
  states: SpecialAccessState[];
}
export interface SpecialAccessWebOfferPageResponse {
  content: {
    thumbnail: ContentThumbnail;
    title: string;
  };
  cta: CTA;
  full_screen_background_image: string;
  gift_box_gif: string;
  gift_box_image: string;
  gift_box_open: string;
  headings: {
    animated_heading: string;
    primary: string;
    secondary: string;
  };
  highlighted_background_image: string;
  login_screen_heading: {
    color: string;
    text: string;
  };
}

export interface SpecialAccessDataWithContent extends SpecialAccessState {
  content: Content;
  current_state_category: ConsumptionStateCategoryEnum;
  current_state_slot: number;
  current_state_value: number;
}
